import { CollapsibleIconButton, Stack, Typography } from '@chronosphereio/chrono-ui';
import React, { useState } from 'react';

type CollapseOptionsProps = {
  title: React.ReactNode;
  titleSummary?: React.ReactNode;
  children: React.ReactNode;
  variant?: 'primary' | 'secondary';
};
export function CollapseOptions(props: CollapseOptionsProps) {
  const { title, titleSummary, variant = 'primary' } = props;
  const [isOptionsCollapsed, setIsOptionsCollapsed] = useState(true);

  return (
    <Stack spacing={1}>
      <Stack
        direction="row"
        alignItems="center"
        spacing={1}
        sx={{ cursor: 'pointer' }}
        onClick={() => setIsOptionsCollapsed(!isOptionsCollapsed)}
      >
        <Stack direction="row" alignItems="center" spacing={0.5}>
          <CollapsibleIconButton collapsed={isOptionsCollapsed} />
          <Typography
            fontWeight={variant === 'primary' ? undefined : 'bold'}
            variant={variant === 'primary' ? 'h4' : 'body2'}
            color={(t) => (variant === 'primary' ? t.palette.text.primary : t.palette.text.secondary)}
          >
            {title}
          </Typography>
        </Stack>
        {isOptionsCollapsed && titleSummary && (
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', minWidth: 0 }}
          >
            {titleSummary}
          </Typography>
        )}
      </Stack>
      {!isOptionsCollapsed && props.children}
    </Stack>
  );
}
